import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-shell',
  templateUrl: './empty-shell.component.html',
  styleUrls: ['./empty-shell.component.scss'],
  standalone: false,
})
export class EmptyShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
